

































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http";
import * as Common from "../../commons/common";

export interface Data {
  errors: any[],
  otp_attempt: string,
}

export default defineComponent({
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: [],
      otp_attempt: "",
    });

    // ログインボタン押下
    const onSubmit = async () => {
      state.errors = [];
      if(state.otp_attempt.length == 0){
        state.errors.push("認証コードを入力してください。");
        return;
      }

      const login_id = context.root.$store.state.otp_login_id;
      await http.post("/api/login/two_factor_authentication", {condition: {otp_attempt: state.otp_attempt, login_id: login_id}})
        .then(response => {
          executeLogin(response)
        })
        .catch(error=>{
          if (error.response.status == 401) {
            state.errors.push("認証に失敗しました。入力したコードを確認してください。");
          }
          if (error.response.status == 403) {
            alert("試行回数の制限を超えました。再度ログインし直してください。");
            context.root.$store.commit("setOtpLoginId", "");
            context.root.$router.push("/").catch(err => {});
          }
          if (error.response.status == 405) {
            state.errors.push("同時にログインできる人数が上限に達しています。");
          }
          if (error.response.status == 406) {
            state.errors.push("現在メンテナンス中のためログインできません。");
          }
          if (error.response.status == 408) {
            alert("認証コードの有効期限が切れています。再度ログインし直してください。");
            context.root.$store.commit("setOtpLoginId", "");
            context.root.$router.push("/").catch(err => {});
          }
        });
    }

    // ログイン成功後の後処理
    const executeLogin = (response: any) => {

      context.root.$store.commit("setOtpLoginId", "");
      
      // トークン設定
      var token = response.data.user.access_token
      document.cookie = 'access_token=' + token;
      document.cookie = 'smarky_user_id=' + response.data.user.id;

      context.root.$store.commit("setCurrentUser", response.data.user);
      context.root.$store.commit("setSchools", response.data.schools);
      context.root.$store.commit("setCurriculums", response.data.curriculums);

      if(!context.root.$store.getters.isOptionEntranceActive && response.data.user.login_count == 1) {
        context.root.$router.push(`/teacher_site/user_edit`).catch(() => {});
      } else {
        context.root.$router.push('/teacher_site/sheet_list').catch(() => {});
      }
    }

    // コード再送信
    const sendAttempt = async () => {

      if (!confirm('認証コードを登録済みのメールアドレスに再送信します。よろしいですか？')) {
        return;
      }
      
      context.root.$store.dispatch("showOverlay");
      const login_id = context.root.$store.state.otp_login_id;
      await http.post(`/api/login/send_attempt`, {condition: {login_id: login_id}}).then(response => {
        alert("認証コードの再送信が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }


    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      document.body.style.background = "whitesmoke";
    })

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      document.body.style.background = "white";
    });

    return {
      ...toRefs(state),
      onSubmit,
      sendAttempt,
    }
  }
})
